import { render, staticRenderFns } from "./addPartener.vue?vue&type=template&id=db91e0a0"
import script from "./addPartener.vue?vue&type=script&lang=js"
export * from "./addPartener.vue?vue&type=script&lang=js"
import style0 from "./addPartener.vue?vue&type=style&index=0&id=db91e0a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports